/*
 * View containing a snippet editor.
 */

define(["marionette", "./template/snippetEditorModalTemplate.html"], function (
  Marionette,
  ResponseEditorModalTemplate,
) {
  const ResponseEditorModalView = {};

  ResponseEditorModalView.snippetEditorModalView = Marionette.Layout.extend({
    template: ResponseEditorModalTemplate,
    regions: {
      htmlEditor: ".html-editor",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return ResponseEditorModalView;
});
